<template>
  <li class="accordion-item link" @click="clickHandler">
    <a v-if="toggle" class="atag" @click.prevent="activate"><slot></slot></a>
    <slot v-else-if="title"></slot>
    <router-link v-else class="atag" :to="{ name: to, query: query }">
      <img v-if="src" :src="image_src" class="img" alt="" />
      <slot></slot>
    </router-link>
  </li>
</template>

<script>
export default {
  name: "AccordionItem",
  props: {
    toggle: { type: Boolean },
    title: { type: Boolean },
    to: { type: String, default: "" },
    query: { type: Object, default: () => {} },
    src: { type: String, default: "" },
  },
  emits: ["click"],
  computed: {
    image_src() {
      return require("@/assets/images/header/" + this.src);
    },
  },
  methods: {
    activate: function () {
      this.$parent.active = !this.$parent.active;
    },
    clickHandler: function (e) {
      this.$emit("click", e);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";

$item_height: 56px;
.accordion-item {
  @include mq-down(md) {
    background-color: $light;
    list-style-type: none;
    background-repeat: no-repeat;
    border-bottom: 1px solid $secondary;
    padding-right: 20px;
    display: block;
    height: $item_height;
    &.-link {
      text-align: left;
      background-color: $white;
      background-image: url("@/assets/images/icons/arrow-right-gray.svg");
      background-position: right 20px center;
      background-size: 8px auto;
      &.-inner {
        padding-right: 20px;
        overflow: hidden;
        height: 0;
        border: none;
        background-image: none;
        transition: height 300ms ease;
      }
    }
    &.disabled {
      opacity: 0.3;
      > .atag {
        color: #9a9a9a;
        cursor: not-allowed;
      }
    }
    &.-toggle {
      cursor: pointer;
      background-image: url("@/assets/images/icons/plus.svg");
      background-position: right 18px center;
      background-size: 14px auto;
    }
    &.-logo {
      > .atag {
        > .img {
          width: 34px;
        }
      }
    }
    .active & {
      &.-toggle {
        background-image: url("@/assets/images/icons/minus.svg");
      }
      &.-inner {
        border-bottom: 1px dotted $secondary;
        background-image: url("@/assets/images/icons/arrow-right-gray.svg");
        height: $item_height;
        transition: height 300ms ease;
      }
      &.-inner:nth-last-of-type(1) {
        border-bottom: 1px solid $secondary;
      }
    }
  }
  @include mq-up(md) {
    margin-bottom: 15px;
  }
  > .atag {
    font-size: 14px;
    line-height: 16px;
    @include mq-down(md) {
      padding: 20px 0 20px 20px;
      @include flex(flex, normal, center, row, nowrap);
      > .img {
        margin-right: 10px;
        width: 40px;
        height: auto;
      }
    }
    @include mq-up(md) {
      line-height: 20px;
      margin-bottom: 15px;
    }
  }
  &.-heading {
    background-color: $light;
    @include mq-up(md) {
      line-height: 25px;
      margin-bottom: 30px;
    }
    > .atag {
      @include mq-up(md) {
        font-weight: bold;
        font-size: 16px;
        line-height: 20px;
        margin-bottom: 15px;
      }
    }
  }
  &.-title {
    height: 30px;
    color: $white;
    font-size: 12px;
    font-weight: bold;
    padding: 5px 0 10px 20px;
    border: none;
    &.-orange {
      background-color: $orange;
    }
    &.-green {
      background-color: $green;
    }
  }
  &.-icon {
    > .atag {
      padding-top: 10px;
      width: 90%;
    }
  }
}
</style>
